import styled from 'styled-components';

export const UiDragTool = styled.div`
  user-select: none;
  height:max-content;
`;